import { useState } from 'react';
import serverErrorHandler from 'services/serverError.service';
import {
  getFormValidationStatusAsync,
  scrollToFormErr,
} from 'utils/form.util';
import type { FormField } from '@urbantxt/form';
import { openSuccessToaster } from 'services/toast.service';
import useUserStore from 'store/useUserStore';
import changePassword from '../api/changePassword';
import getUserSession from '../api/getUserSession';
import { authPasswordWithConfirmFormModel as model } from '../validation/schemas';

export interface IChangePasswordForm {
  password: string;
  passwordConfirm: string;
}

const INIT_FORM = {
  password: '',
  passwordConfirm: '',
};

const fields: FormField[] = [
  {
    name: 'password',
    type: 'password',
    label: 'New Password',
    size: 'lg',
    data: null,
  },
  {
    name: 'passwordConfirm',
    type: 'password',
    label: 'Confirm New Password',
    size: 'lg',
    data: null,
  },
];

export default function useChangePassword() {
  const [formValue, setFormValue] =
    useState<IChangePasswordForm>(INIT_FORM);
  const [isLoading, setIsLoading] = useState(false);

  /**
   * Handles password change submission
   * On success, reloads user session and redirects to dashboard
   */
  const onSubmit = async () => {
    try {
      const isValid = await getFormValidationStatusAsync(
        model.check(formValue),
      );

      if (isValid) {
        setIsLoading(true);

        // Call API to change password
        await changePassword({
          newPassword: formValue.password,
        });

        // Reload user session to get updated mustChangePassword flag
        const updatedUser = await getUserSession();
        useUserStore.getState().setUser(updatedUser);

        openSuccessToaster('Password changed successfully.', 3500);
        setIsLoading(false);

        // Reload page to re-fetch session and update routing
        window.location.reload();
      } else {
        scrollToFormErr();
      }
    } catch (e) {
      setIsLoading(false);
      serverErrorHandler(e);
    }
  };

  const onChange = (val: any) => {
    setFormValue(val);
  };

  return {
    fields,
    formValue,
    isLoading,
    model,
    onChange,
    onSubmit,
  };
}
